export default class AbortControllerModule {
  constructor() {
    this.controller = new AbortController();
  }

  createController() {
    this.controller = new AbortController();
  }

  abort() {
    this.controller.abort();
  }
}

export const CommonAbortController = new AbortControllerModule();
export const ABORT_MESSAGE = "The user aborted a request.";
